var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"avatar"}}),_c('div',{staticClass:"main"},[_c('Left'),_c('Right')],1),_c('Buttons'),_c('Msg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }